import { useScopedTranslation } from 'application/localization/useScopedTranslation';
import { type AdvancedFormReturnType } from 'helpers/form/useAdvancedForm';
import { Field } from 'components/uikit/Field';
import { TextArea } from 'components/uikit/inputs/TextArea.tsx';
import { CreateProjectDto } from 'services/api/api-client';
import styles from './ProjectModal.module.scss';

type ProjectAITabProps = {
  form: AdvancedFormReturnType<CreateProjectDto>;
};

export const ProjectAITab: React.FC<ProjectAITabProps> = ({ form }) => {
  const i18n = useScopedTranslation('Component.ProjectModal');

  return (
    <>
      <div className={styles.helperText}>
        {i18n.t('project_context_helper_text')}
      </div>
      <Field title={i18n.t('ai_context_field')} className={styles.inputField}>
        <TextArea
          {...form.register('settings.context')}
          errorText={form.formState.errors.settings?.context?.message}
        />
      </Field>
    </>
  );
};
